"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = exports.formatStandard = exports.formatDateOnly = exports.formatDateOnlyWithTimezone = exports.formatDateOnlyWithoutDay = void 0;
var DISPLAY_TIMEZONE = 'America/New_York';
var formatDateOnlyWithoutDay = function (datetime) {
    return (0, exports.format)(datetime, { includeMonth: true, includeYear: true });
};
exports.formatDateOnlyWithoutDay = formatDateOnlyWithoutDay;
var formatDateOnlyWithTimezone = function (datetime) {
    return (0, exports.format)(datetime, {
        includeDay: true,
        includeMonth: true,
        includeYear: true,
        includeTimeZone: true,
    });
};
exports.formatDateOnlyWithTimezone = formatDateOnlyWithTimezone;
var formatDateOnly = function (datetime) {
    return (0, exports.format)(datetime, { includeDay: true, includeMonth: true, includeYear: true });
};
exports.formatDateOnly = formatDateOnly;
var formatStandard = function (datetime) {
    return (0, exports.format)(datetime, { includeDay: true, includeMonth: true, includeYear: true, includeTime: true });
};
exports.formatStandard = formatStandard;
var format = function (datetime, options) {
    return "".concat(new Intl.DateTimeFormat('en-US', {
        day: options.includeDay ? 'numeric' : undefined,
        month: options.includeMonth ? 'long' : undefined,
        year: options.includeYear ? 'numeric' : undefined,
        hour: options.includeTime ? '2-digit' : undefined,
        minute: options.includeTime ? '2-digit' : undefined,
        timeZone: DISPLAY_TIMEZONE,
    }).format(new Date(datetime))).concat(options.includeTimeZone ? " ".concat(DISPLAY_TIMEZONE) : '');
};
exports.format = format;
